module.exports = "<div class=\"navigation-container\">\n    <button\n      ng-if=\"$ctrl.isStateEnabled($ctrl.next)\"\n      type=\"button\" class=\"btn button-next pull-right\"\n      ng-class=\"{'data-changed-nest': $ctrl.highlight }\"\n      ng-click=\"$ctrl.goNext()\">\n      Next<span class=\"glyphicon glyphicon-menu-right button-arrow\"></span>\n    </button>\n</div>\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/page-navigation/page-navigation.html
// module id = 465
// module chunks = 0